import "bootstrap/dist/css/bootstrap.min.css";
import "./styles.css";

import App from "./App";
import reportWebVitals from "./reportWebVitals";

import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import { ThemeProvider } from "react-bootstrap";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <ThemeProvider
    breakpoints={['xxxl', 'xxl', 'xl', 'lg', 'md', 'sm', 'xs', 'xxs']}
    minBreakpoint="xxs"
  >
    <Router>
      <App />
    </Router>
  </ThemeProvider>
);

reportWebVitals();
